import { BleClient } from '@capacitor-community/bluetooth-le'
import { Capacitor } from '@capacitor/core'
import { Geolocation } from '@capacitor/geolocation'

export async function initBluetooth({ openSettingsIfFail = true } = {}) {
  try {
    await BleClient.initialize()
    let enabled = await BleClient.isEnabled()

    if (!enabled) {
      try {
        await BleClient.requestEnable()
        enabled = await BleClient.isEnabled()
      } catch {
        if (openSettingsIfFail) await BleClient.openBluetoothSettings()
        return false
      }
      if (!enabled && openSettingsIfFail) {
        await BleClient.openBluetoothSettings()
      }
    }
    return enabled
  } catch (err) {
    console.error('[BLE Init Error]', err)
    if (openSettingsIfFail) {
      try {
        await BleClient.openBluetoothSettings()
      } catch (e) {
        console.error('Failed to open Bluetooth settings:', e)
      }
    }
    return false
  }
}

export const isBleSupported = async () => {
  if (Capacitor.getPlatform() === 'web') return false
  try {
    await BleClient.initialize()
    return true
  } catch (err) {
    console.warn('BLE not supported or init failed:', err)
    return false
  }
}

export const checkLocationPermission = async () => {
  try {
    const permissions = await Geolocation.checkPermissions()
    return permissions.location === 'granted'
  } catch (e) {
    console.error('Location check error:', e)
    return false
  }
}

export const requestLocationPermission = async () => {
  try {
    const result = await Geolocation.requestPermissions()
    return result.location === 'granted'
  } catch (e) {
    console.error('Location request error:', e)
    return false
  }
}
